// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./wv-img-4.jpg");
var dir = previousRequest.replace("wv-img-4.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "wv-img-4.jpg",
	name: "wv-img-4",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/wv-img-4.jpg
// module id = 95
// module chunks = 4